import { useState } from 'react';
import Button from '../Components/Buttons';
import { ConfirmationProvider } from '../Components/ConfirmationContext';
import {
  CustomCheckbox,
  CustomCircleRating,
  CustomCodeEditor,
  CustomFileUpload,
  CustomInput,
  CustomNumberInput,
  CustomRadioGroup,
  CustomSelect,
  CustomSlider,
  CustomTextarea,
  CustomToggle,
  CustomWYSIWYGEditor,
} from '../Components/CustomFormElements';
import PageLoader from '../Components/PageLoader';
import SureLoader from '../Components/SureLoader';
import TableLoader from '../Components/TableLoader';
import Table from '../Components/Tables';

// TABLE COMPONENTS
function ListOfComponents() {
  const handleClick = (type) => {
    alert(`${type} button clicked!`);
  };

  const columns = [
    {
      name: 'Title',
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: 'Year',
      selector: (row) => row.year,
      sortable: true,
    },
    {
      name: 'Another content',
      selector: (row) => row.another,
      sortable: true,
    },
  ];

  const data = [
    {
      id: 1,
      title: 'Beetlejuice',
      year: '1988',
      another: 'content',
      description: 'A classic horror-comedy.',
    },
    { id: 2, title: 'Ghostbusters', year: '1984', another: 'content' },
    {
      id: 3,
      title: 'Inception',
      year: '2010',
      another: 'content',
      description: '<b>Mind-bending thriller</b>',
    },
    {
      id: 4,
      title: 'Inception',
      year: '2010',
      another: 'content',
      description: '<b>Mind-bending thriller</b>',
    },
    {
      id: 5,
      title: 'Inception',
      year: '2010',
      another: 'content',
      description: '<b>Mind-bending thriller</b>',
    },
    {
      id: 6,
      title: 'Inception',
      year: '2010',
      another: 'content',
      description: '<b>Mind-bending thriller</b>',
    },
    {
      id: 7,
      title: 'Inception',
      year: '2010',
      another: 'content',
      description: '<b>Mind-bending thriller</b>',
    },
  ];
  // END OF TABLE

  // CHECKBOX STATE

  const [isAccepted, setIsAccepted] = useState(false);

  // TOGGLE STATE
  const [isActive1, setIsActive1] = useState(true);
  const [isActive2, setIsActive2] = useState(true);

  const handleRadioGroupChange = (value) => {
    console.log('Selected value:', value);
  };
  // END OF RADIOBUTTON

  return (
    <div className="container gap">
      {/* Basic CSS ================================================ */}
      <h2 className="h2-title">Basic CSS</h2>
      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes col-12">
          <p>Basic CSS styles to be applied acroll the whole app</p>
          <CustomCodeEditor
            value={`/* =========================  FRAMEWORK  ===================================== */

/* === GLOBAL STYLES === */
.container {
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  box-sizing: border-box;
  max-width: 1660px;
  padding: 20px 0px;
}

/* === ROW === */
.row {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

/* === DISPLAY FLEX === */

.d-flex{
  display: flex;
}

.folded{
  flex-wrap: wrap;
}

/* === COLUMN SIZES === */
.col-1 {width: 88px;}
.col-2 {width: 228px;}
.col-3 {width: 368px;}
.col-4 {width: 508px;}
.col-5 {width: 648px;}
.col-6 {width: 788px;}
.col-7 {width: 928px;}
.col-8 {width: 1068px;}
.col-9 {width: 1208px;}
.col-10 {width: 1348px;}
.col-11 {width: 1488px;}
.col-12 {width: 100%;}

@media (max-width: 1500px) {
.col-1 {width: 61px;}
.col-2 {width: 174px;}
.col-3 {width: 287px;}
.col-4 {width: 400px;}
.col-5 {width: 513px;}
.col-6 {width: 626px;}
.col-7 {width: 740px;}
.col-8 {width: 854px;}
.col-9 {width: 969px;}
.col-10 {width: 1082px;}
.col-11 {width: 1195px;}
.col-12 {width: 100%;}
}

/* === RESPONSIVE CONDITIONS FOR 1 COL BOXES */
@media (max-width: 1200px) {
  .full-width-on-sml-scr{
    width: 100% !important;
    flex: 0 1 100% !important;
  }
  
}


/* === COLUMN SIZES === */
.int-col-1 {flex: 0 1 24%; min-width: 200px; box-sizing: border-box;}
.int-col-2 {flex: 0 1 49.3%; min-width: 200px; box-sizing: border-box;}
.int-col-3 {flex: 0 1 72%; min-width: 200px; box-sizing: border-box;}
.int-col-4 {flex: 0 1 100%; min-width: 200px; box-sizing: border-box;}

/* Ensure wrapping on smaller screens */
@media (max-width: 768px) {
  .int-col-2, .int-col-3  {
      flex: 0 1 100%; /* Each column takes full width on smaller screens */
  }
}

/* === WIDTH BOXES === */
.min-width-100 { min-width: 100px; }
.min-width-200 { min-width: 200px; }
.min-width-300 { min-width: 300px; }

.max-width-100 { max-width: 100px; }
.max-width-200 { max-width: 200px; }
.max-width-300 { max-width: 300px; }
.max-width-400 { max-width: 400px; }
.max-width-500 { max-width: 500px; }
.max-width-600 { max-width: 600px; }
.max-width-700 { max-width: 700px; }

.w-100{width: 100%;}

/* === BACKGROUND UTILITY CLASSES === */
.bg-yes { background-color: var(--bs-box-bg); }
.bg-no { background-color: transparent; }

/* === BORDER UTILITY CLASSES === */
.border-yes  { border: 1px solid var(--border-color); }
.border-no { border: none; }

/* === BORDER RADIUS UTILITY CLASSES === */
.radius-yes { border-radius: 8px; }
.radius-no { border-radius: 0; }

/* === PADDING UTILITY CLASSES === */
.p-0 { padding: 0; }
.p-1 { padding: 10px; }
.p-2 { padding: 15px; }
.p-3 { padding: 20px; }
.p-4 { padding: 30px; }

/* === MARGIN UTILITY CLASSES === */
.m-full-0 { margin: 0; }
.m-full-1 { margin: 10px; }
.m-full-2 { margin: 15px;  }
.m-full-3 { margin: 20px; }
.m-full-4 { margin: 25px; }

.m-0 { margin: 0; }
.m-1 { margin: 10px 0; }
.m-2 { margin: 15px 0;  }
.m-3 { margin: 20px 0; }
.m-4 { margin: 25px 0; }

.ml-0 { margin-left: 0;}
.ml-1 { margin-left: 10px;}
.ml-2 { margin-left: 15px;}
.ml-3 { margin-left: 20px;}

/* === GAP UTILITY CLASSES === */
.gap { gap: 20px; }

/* === ALIGNMENT CLASSES === */
.align-start { align-items: flex-start; }
.align-center { align-items: center; }
.align-end { align-items: flex-end; }
.justify-start { justify-content: flex-start; }
.justify-center { justify-content: center; }
.justify-end { justify-content: flex-end; }
.justify-between { justify-content: space-between; }
.justify-around { justify-content: space-around; }

/* === FLEX DIRECTION === */
.flex-row { flex-direction: row; }
.flex-row-reverse { flex-direction: row-reverse; }
.flex-column { flex-direction: column; }
.flex-column-reverse { flex-direction: column-reverse; }


@media (max-width: 768px) {
  .flex-row-to-col  {
      flex-direction: column !important; /* Each column takes full width on smaller screens */
  }
}


/* ===== FONTS AND TITLES ==== */
.h1-title{
  font-size: var(--h1);
  margin: 24px 0 32px 0;
  font-weight: var(--bold);
}

.h1-title::after{
  content: '';
  width: 80px;
  display: block;
  border-bottom: 2px solid var(--font-color-body);
  margin: 10px 0 0 20px;
}

.h2-title{
  font-size: var(--h2);
  margin: 16px 0 24px 0;
  font-weight: var(--bold);
}

.h2-title::after{
  content: '';
  width: 80px;
  display: block;
  border-bottom: 1px solid var(--font-color-body);
  margin: 10px 0 0 20px;
}

.h3-title{
  font-size: var(--h3);
  margin: 8px 0 16px 0;
  font-weight: var(--bold);
}

.h3-title::after{
  content: '';
  width: 80px;
  display: block;
  border-bottom: 1px solid var(--font-color-body);
  margin: 10px 0 0 20px;
}

.h4-title{
  font-size: var(--h4);
  margin: 8px 0 8px 0;
  font-weight: var(--bold);
}

.h4-title::after{
  content: '';
  width: 80px;
  display: block;
  border-bottom: 1px solid var(--font-color-body);
  margin: 10px 0 0 20px;
}

.headline {
  font-size: var(--headline);
  display: block;
  margin: 8px 0 8px 0;
  font-weight: var(--semibold);
}

.small-font{
  font-size: var(--body-small);
}

.medium-font{
  font-size: var(--body-medium);
  font-weight: var(--semibold);
}

.large-font{
  font-size: var(--body-large);
  font-weight: var(--);
}

.light {
  font-weight: var(--light);
}

.regular {
  font-weight: var(--regular);
}

.semibold {
  font-weight: var(--semibold);
}

.bold {
  font-weight: var(--bold);
}

/* =============================== END OF FRAMEWORK ================================ */
                                `}
            boxtitle="CSS"
            wrapText={true}
            language="css"
            editable={false}
            height="4200px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />
        </div>
      </div>

      {/* Row with 1-col boxes ================================================ */}
      <h2 className="h2-title">Layout options</h2>
      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes   col-1">
          <p>1 columns</p>
          <CustomCodeEditor
            value={`<div className="row d-flex gap">
    <div className="radius-yes p-2 bg-yes   col-1"></div>
    <div className="radius-yes p-2 bg-yes   col-1"></div>
    <div className="radius-yes p-2 bg-yes   col-1"></div>
    <div className="radius-yes p-2 bg-yes   col-1"></div>
    <div className="radius-yes p-2 bg-yes   col-1"></div>
    <div className="radius-yes p-2 bg-yes   col-1"></div>
    <div className="radius-yes p-2 bg-yes   col-1"></div>
    <div className="radius-yes p-2 bg-yes   col-1"></div>
    <div className="radius-yes p-2 bg-yes   col-1"></div>
    <div className="radius-yes p-2 bg-yes   col-1"></div>
    <div className="radius-yes p-2 bg-yes   col-1"></div>
    <div className="radius-yes p-2 bg-yes   col-1"></div>
</div>`}
            boxtitle="HTML"
            wrapText={true}
            language="html"
            editable={false}
            height="100px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />
        </div>
        <div className="radius-yes p-2 bg-yes   col-1">
          <p>1 columns</p>
          <div className="col-4"></div>
        </div>
        <div className="radius-yes p-2 bg-yes   col-1">
          <p>1 columns</p>
          <div className="col-4"></div>
        </div>
        <div className="radius-yes p-2 bg-yes   col-1">
          <p>1 columns</p>
          <div className="col-4"></div>
        </div>
        <div className="radius-yes p-2 bg-yes   col-1">
          <p>1 columns</p>
          <div className="col-4"></div>
        </div>
        <div className="radius-yes p-2 bg-yes   col-1">
          <p>1 columns</p>
          <div className="col-4"></div>
        </div>
        <div className="radius-yes p-2 bg-yes   col-1">
          <p>1 columns</p>
          <div className="col-4"></div>
        </div>
        <div className="radius-yes p-2 bg-yes   col-1">
          <p>1 columns</p>
          <div className="col-4"></div>
        </div>
        <div className="radius-yes p-2 bg-yes   col-1">
          <p>1 columns</p>
          <div className="col-4"></div>
        </div>
        <div className="radius-yes p-2 bg-yes   col-1">
          <p>1 columns</p>
          <div className="col-4"></div>
        </div>
        <div className="radius-yes p-2 bg-yes   col-1">
          <p>1 columns</p>
          <div className="col-4"></div>
        </div>
        <div className="radius-yes p-2 bg-yes   col-1">
          <p>1 columns</p>
          <div className="col-4"></div>
        </div>
      </div>

      {/* Row with 2-col boxes ================================================ */}

      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes   col-2">
          <p>2 columns</p>
          <CustomCodeEditor
            value={`<div className="row d-flex gap">
    <div className="radius-yes p-2 bg-yes   col-2"></div>
    <div className="radius-yes p-2 bg-yes   col-2"></div>
    <div className="radius-yes p-2 bg-yes   col-2"></div>
    <div className="radius-yes p-2 bg-yes   col-2"></div>
    <div className="radius-yes p-2 bg-yes   col-2"></div>
    <div className="radius-yes p-2 bg-yes   col-2"></div>

</div>`}
            boxtitle="HTML"
            wrapText={true}
            language="html"
            editable={false}
            height="100px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />
        </div>
        <div className="radius-yes p-2 bg-yes   col-2">
          <p>2 columns</p>
          <div className="col-4"></div>
        </div>
        <div className="radius-yes p-2 bg-yes   col-2">
          <p>2 columns</p>
          <div className="col-4"></div>
        </div>
        <div className="radius-yes p-2 bg-yes   col-2">
          <p>2 columns</p>
          <div className="col-4"></div>
        </div>
        <div className="radius-yes p-2 bg-yes   col-2">
          <p>2 columns</p>
          <div className="col-4"></div>
        </div>
        <div className="radius-yes p-2 bg-yes   col-2">
          <p>2 columns</p>
          <div className="col-4"></div>
        </div>
      </div>

      {/* Row with 3-col boxes ================================================ */}

      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes   col-3">
          <p>3 columns</p>
          <CustomCodeEditor
            value={`<div className="row d-flex gap">
    <div className="radius-yes p-2 bg-yes   col-3"></div>
    <div className="radius-yes p-2 bg-yes   col-3"></div>
    <div className="radius-yes p-2 bg-yes   col-3"></div>
    <div className="radius-yes p-2 bg-yes   col-3"></div>
</div>`}
            boxtitle="HTML"
            wrapText={true}
            language="html"
            editable={false}
            height="100px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />
        </div>
        <div className="radius-yes p-2 bg-yes   col-3">
          <p>3 columns</p>
          <div className="col-4"></div>
        </div>
        <div className="radius-yes p-2 bg-yes   col-3">
          <p>3 columns</p>
          <div className="col-4"></div>
        </div>
        <div className="radius-yes p-2 bg-yes   col-3">
          <p>3 columns</p>
          <div className="col-4"></div>
        </div>
      </div>

      {/* Row with 4-col boxes ================================================ */}

      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes   col-4">
          <p>4 columns</p>
          <CustomCodeEditor
            value={`<div className="row d-flex gap">
    <div className="radius-yes p-2 bg-yes   col-4"></div>
    <div className="radius-yes p-2 bg-yes   col-4"></div>
    <div className="radius-yes p-2 bg-yes   col-4"></div>
</div>`}
            boxtitle="HTML"
            wrapText={true}
            language="html"
            editable={false}
            height="100px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />
        </div>
        <div className="radius-yes p-2 bg-yes   col-4">
          <p>4 columns</p>
        </div>
        <div className="radius-yes p-2 bg-yes   col-4">
          <p>4 columns</p>
        </div>
      </div>

      {/* Row with 5-col boxes ================================================ */}

      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes   col-5">
          <p>5 columns</p>
          <CustomCodeEditor
            value={`<div className="row d-flex gap">
    <div className="radius-yes p-2 bg-yes   col-5"></div>
    <div className="radius-yes p-2 bg-yes   col-5"></div>
    <div className="radius-yes p-2 bg-yes   col-2"></div>
</div>`}
            boxtitle="HTML"
            wrapText={true}
            language="html"
            editable={false}
            height="100px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />
        </div>
        <div className="radius-yes p-2 bg-yes   col-5">
          <p>5 columns</p>
        </div>
        <div className="radius-yes p-2 bg-yes   col-2">
          <p>2 columns</p>
        </div>
      </div>

      {/* Row with 6-col boxes ================================================ */}

      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes   col-6">
          <p>6 columns</p>
          <CustomCodeEditor
            value={`<div className="row d-flex gap">
    <div className="radius-yes p-2 bg-yes   col-6"></div>
    <div className="radius-yes p-2 bg-yes   col-6"></div>
</div>`}
            boxtitle="HTML"
            wrapText={true}
            language="html"
            editable={false}
            height="100px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />
        </div>
        <div className="radius-yes p-2 bg-yes   col-6">
          <p>6 columns</p>
        </div>
      </div>

      {/* Row with 7-col boxes ================================================ */}

      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes   col-7">
          <p>7 columns</p>
          <CustomCodeEditor
            value={`<div className="row d-flex gap">
    <div className="radius-yes p-2 bg-yes   col-7"></div>
    <div className="radius-yes p-2 bg-yes   col-5"></div>
</div>`}
            boxtitle="HTML"
            wrapText={true}
            language="html"
            editable={false}
            height="100px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />
        </div>
        <div className="radius-yes p-2 bg-yes   col-5">
          <p>5 columns</p>
        </div>
      </div>

      {/* Row with 8-col boxes ================================================ */}

      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes   col-8">
          <p>8 columns</p>
          <CustomCodeEditor
            value={`<div className="row d-flex gap">
    <div className="radius-yes p-2 bg-yes   col-8"></div>
    <div className="radius-yes p-2 bg-yes   col-4"></div>
</div>`}
            boxtitle="HTML"
            wrapText={true}
            language="html"
            editable={false}
            height="100px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />
        </div>
        <div className="radius-yes p-2 bg-yes   col-4">
          <p>4 columns</p>
        </div>
      </div>

      {/* Row with 9-col boxes ================================================ */}

      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes   col-9">
          <p>9 columns</p>
          <CustomCodeEditor
            value={`<div className="row d-flex gap">
    <div className="radius-yes p-2 bg-yes   col-9"></div>
    <div className="radius-yes p-2 bg-yes   col-3"></div>
</div>`}
            boxtitle="HTML"
            wrapText={true}
            language="html"
            editable={false}
            height="100px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />
        </div>
        <div className="radius-yes p-2 bg-yes   col-3">
          <p>3 columns</p>
        </div>
      </div>

      {/* Row with 10-col boxes ================================================ */}

      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes   col-10">
          <p>10 columns</p>
          <CustomCodeEditor
            value={`<div className="row d-flex gap">
    <div className="radius-yes p-2 bg-yes   col-10"></div>
    <div className="radius-yes p-2 bg-yes   col-2"></div>
</div>`}
            boxtitle="HTML"
            wrapText={true}
            language="html"
            editable={false}
            height="100px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />
        </div>
        <div className="radius-yes p-2 bg-yes   col-2">
          <p>2 columns</p>
        </div>
      </div>

      {/* Row with 11-col boxes ================================================ */}

      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes   col-11">
          <p>11 columns</p>
          <CustomCodeEditor
            value={`<div className="row d-flex gap">
    <div className="radius-yes p-2 bg-yes   col-11"></div>
    <div className="radius-yes p-2 bg-yes   col-1"></div>
</div>`}
            boxtitle="HTML"
            wrapText={true}
            language="html"
            editable={false}
            height="100px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />
        </div>
        <div className="radius-yes p-2 bg-yes   col-1">
          <p>1 columns</p>
        </div>
      </div>

      {/* Row with full width box ================================================ */}

      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes   col-12">
          <p>Full Width Row</p>
          <CustomCodeEditor
            value={`<div className="row d-flex gap">
    <div className="radius-yes p-2 bg-yes   col-12"></div>
</div>`}
            boxtitle="HTML"
            wrapText={true}
            language="html"
            editable={false}
            height="100px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />
        </div>
      </div>

      {/* Row with partly filled box ================================================ */}

      <div className="d-flex radius-yes p-2 bg-yes col-12 flex-column gap">
        <div className="int-col-4 p-2">
          <h1 className="h3-title">Create New Organization</h1>
        </div>

        <div className="int-col-4 gap d-flex flex-row-to-col">
          <div className="int-col-2 p-2 border-yes radius-yes full-width-on-sml-scr">
            {/* Organization Name Input */}
            <div className="input-row input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Organization Name</div>
                <div className="small-font">Enter your organization's name</div>
              </div>
              <div className="align-wrapper d-flex align-center"></div>
            </div>

            {/* Toggle for Active/Inactive */}
            <div className="input-row input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Status</div>
                <div className="small-font">Set organization as Active or Inactive</div>
              </div>
              <div className="align-wrapper d-flex align-center"></div>
            </div>

            {/* Buttons */}
            <div className="buttons-block w-100 justify-end d-flex flex-row flex-row-to-col gap"></div>
          </div>
        </div>

        <div className="int-col-4 gap d-flex flex-column">
          <p>Row with partly filled box</p>
          <CustomCodeEditor
            value={`<div className="d-flex radius-yes p-2 bg-yes col-12 flex-column gap">
    <div className='int-col-4 p-2'>
        <h1 className='h3-title'>Create New Organization</h1>
    </div>

    <div className='int-col-4 gap d-flex flex-row-to-col'>

        <div className='int-col-2 p-2 border-yes radius-yes full-width-on-sml-scr'>

            {/* Organization Name Input */}
            <div className='input-row input-block d-flex flex-row justify-between'>
                <div className='input-description'>
                    <div className='input-title'>Organization Name</div>
                    <div className='small-font'>Enter your organization's name</div>
                </div>
                <div className='align-wrapper d-flex align-center'>
                    
                </div>
            </div>

            {/* Toggle for Active/Inactive */}
            <div className='input-row input-block d-flex flex-row justify-between'>
                <div className='input-description'>
                    <div className='input-title'>Status</div>
                    <div className='small-font'>Set organization as Active or Inactive</div>
                </div>
                <div className='align-wrapper d-flex align-center'>
                
                </div>
            </div>

            {/* Buttons */}
            <div className='buttons-block w-100 justify-end d-flex flex-row flex-row-to-col gap'>

            </div>
        </div>

    </div>
</div>`}
            boxtitle="JSX"
            wrapText={true}
            language="javascript"
            editable={false}
            height="800px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />
        </div>
      </div>

      {/* Titles and fonts ================================================ */}

      <h2 className="h2-title">Titles and fonts</h2>
      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes   col-12">
          <h1 className="h1-title">H1 Title</h1>
          <h2 className="h2-title">H2 Title</h2>
          <h3 className="h3-title">H3 Title</h3>
          <h4 className="h4-title">H4 Title</h4>
          <span className="headline">This is headline text</span>
          <p className="small-font">
            <span className="light">This is small font in paragraph</span> <br />
            <span className="regular">This is small font in paragraph</span> <br />
            <span className="semibold">This is small font in paragraph</span> <br />
            <span className="bold">This is small font in paragraph</span> <br />
          </p>
          <p className="medium-font">
            <span className="light">This is medium font in paragraph</span> <br />
            <span className="regular">This is medium font in paragraph</span> <br />
            <span className="semibold">This is medium font in paragraph</span> <br />
            <span className="bold">This is medium font in paragraph</span> <br />
          </p>
          <p className="large-font">
            <span className="light">This is large font in paragraph</span> <br />
            <span className="regular">This is large font in paragraph</span> <br />
            <span className="semibold">This is large font in paragraph</span> <br />
            <span className="bold">This is large font in paragraph</span> <br />
          </p>

          <CustomCodeEditor
            value={`
<h1 className='h1-title'>H1 Title</h1>
<h2 className='h2-title'>H2 Title</h2>
<h3 className='h3-title'>H3 Title</h3>
<h4 className='h4-title'>H4 Title</h4>
<span className='headline'>This is headline text</span>
<p className='small-font'>
    <span className='light'>This is small font in paragraph</span> <br/> 
    <span className='regular'>This is small font in paragraph</span> <br/>
    <span className='semibold'>This is small font in paragraph</span> <br/>
    <span className='bold'>This is small font in paragraph</span> <br/>
</p>
<p className='medium-font'>
    <span className='light'>This is medium font in paragraph</span> <br/> 
    <span className='regular'>This is medium font in paragraph</span> <br/>
    <span className='semibold'>This is medium font in paragraph</span> <br/> 
    <span className='bold'>This is medium font in paragraph</span> <br/> 
</p> 
<p className='large-font'>
    <span className='light'>This is large font in paragraph</span> <br/>
    <span className='regular'>This is large font in paragraph</span> <br/>
    <span className='semibold'>This is large font in paragraph</span> <br/>
    <span className='bold'>This is large font in paragraph</span> <br/>
</p>
                                `}
            boxtitle="HTML"
            wrapText={true}
            language="html"
            editable={false}
            height="500px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />
        </div>
      </div>

      {/* Loaders ================================================ */}

      <h2 className="h2-title">Loaders</h2>
      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes col-4">
          <h3 className="h4-title">Table loader</h3>
          <TableLoader rows={5} columns={4} />
        </div>
        <div className="radius-yes p-2 bg-yes col-4">
          <h3 className="h4-title">Page loader</h3>
          <PageLoader blockHeights={[10, 100, 10, 10, 10]} />
        </div>
        <div className="radius-yes p-2 bg-yes col-4">
          <SureLoader />
        </div>

        <div className="radius-yes p-2 bg-yes col-12">
          <CustomCodeEditor
            value={`<div className="radius-yes p-2 bg-yes col-4">
    <h3 className='h4-title'>Table loader</h3>
    <TableLoader rows={5} columns={4}/>
</div>
<div className="radius-yes p-2 bg-yes col-4">
    <h3 className='h4-title'>Page loader</h3>
    <PageLoader blockHeights={[10, 100, 10, 10, 10]}/>    
</div>
<div className="radius-yes p-2 bg-yes col-4">
    <SureLoader />                        
</div>`}
            boxtitle="JSX"
            wrapText={true}
            language="javascript"
            editable={false}
            height="300px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />
        </div>
      </div>

      {/* Tables ================================================ */}
      <h2 className="h2-title">Tables</h2>
      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes   col-12">
          <ConfirmationProvider>
            <Table
              title="Hello this is title"
              columns={columns}
              data={data}
              selectableRows={true}
              selectableRowsHighlight={true}
              expandableRows={true}
              paginationPerPage={5}
              dense={false}
              noTableHead={false}
              disabled={false}
              onRowClicked={(row) => console.log('Row clicked:', row)}
              onRowDoubleClicked={(row) => console.log('Row double clicked:', row)}
              onRowMouseEnter={(row) => console.log('Mouse entered:', row)}
              onRowMouseLeave={(row) => console.log('Mouse left:', row)}
            />
          </ConfirmationProvider>

          <div className="m-4">
            <CustomCodeEditor
              value={`
import Table from '../Components/Tables';

const columns = [
    {
        name: 'Title',
        selector: (row) => row.title,
        sortable: true,
    },
    {
        name: 'Year',
        selector: (row) => row.year,
        sortable: true,
    },
];

const data = [
    { id: 1, title: 'Beetlejuice', year: '1988', description: 'A classic horror-comedy.' },
    { id: 2, title: 'Ghostbusters', year: '1984' },
    { id: 3, title: 'Inception', year: '2010', description: '<b>Mind-bending thriller</b>' },
    { id: 4, title: 'Inception', year: '2010', description: '<b>Mind-bending thriller</b>' },
    { id: 5, title: 'Inception', year: '2010', description: '<b>Mind-bending thriller</b>' },
    { id: 6, title: 'Inception', year: '2010', description: '<b>Mind-bending thriller</b>' },
    { id: 7, title: 'Inception', year: '2010', description: '<b>Mind-bending thriller</b>' },
];
return (
    <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes   col-12">
          
                <ConfirmationProvider>
                    <Table
                        title="Hello this is title"
                        columns={columns}
                        data={data}
                        selectableRows={true}
                        selectableRowsHighlight={true}
                        expandableRows={true}
                        paginationPerPage={5}
                        dense={false}
                        noTableHead={false}
                        disabled={false}
                        onRowClicked={(row) => console.log('Row clicked:', row)}
                        onRowDoubleClicked={(row) => console.log('Row double clicked:', row)}
                        onRowMouseEnter={(row) => console.log('Mouse entered:', row)}
                        onRowMouseLeave={(row) => console.log('Mouse left:', row)}
                    />
                </ConfirmationProvider>
        </div>
    </div>           
);
`}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="500px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>
        </div>
      </div>

      {/* Buttons ============================================================= */}

      <h2 className="h2-title">Buttons</h2>
      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes   col-12">
          <span className="headline">Primary small</span>
          <Button variant="primary" size="small" onClick={handleClick}>
            Primary small
          </Button>

          <CustomCodeEditor
            value={`import Button from '../Components/Buttons';

<Button variant="primary" size='small' onClick={handleClick}>
    Primary small
</Button>
`}
            boxtitle="JSX"
            wrapText={true}
            language="javascript"
            editable={false}
            height="150px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />

          <span className="headline">Primary medium</span>
          <Button variant="primary" size="medium" onClick={() => handleClick('Secondary')}>
            Primary medium
          </Button>

          <CustomCodeEditor
            value={`import Button from '../Components/Buttons';

<Button variant="primary" size='medium' onClick={handleClick}>
    Primary medium
</Button>
`}
            boxtitle="JSX"
            wrapText={true}
            language="javascript"
            editable={false}
            height="150px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />

          <span className="headline">Primary Large</span>
          <Button variant="primary" size="large" onClick={handleClick}>
            Primary large
          </Button>

          <CustomCodeEditor
            value={`import Button from '../Components/Buttons';

<Button variant="primary" size='large' onClick={handleClick}>
    Primary large
</Button>
`}
            boxtitle="JSX"
            wrapText={true}
            language="javascript"
            editable={false}
            height="150px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />

          <span className="headline">Secondary small</span>
          <Button variant="secondary" size="small" onClick={handleClick}>
            Secondary small
          </Button>

          <CustomCodeEditor
            value={`import Button from '../Components/Buttons';

<Button variant="secondary" size='small' onClick={handleClick}>
    Secondary small
</Button>
`}
            boxtitle="JSX"
            wrapText={true}
            language="javascript"
            editable={false}
            height="150px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />

          <span className="headline">Secondary medium</span>
          <Button variant="secondary" size="medium" onClick={handleClick}>
            Secondary medium
          </Button>

          <CustomCodeEditor
            value={`import Button from '../Components/Buttons';

<Button variant="secondary" size='medium' onClick={handleClick}>
    Secondary small
</Button>
`}
            boxtitle="JSX"
            wrapText={true}
            language="javascript"
            editable={false}
            height="150px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />

          <span className="headline">Secondary large</span>
          <Button variant="secondary" size="large" onClick={handleClick}>
            Secondary large
          </Button>

          <CustomCodeEditor
            value={`import Button from '../Components/Buttons';

<Button variant="secondary" size='large' onClick={handleClick}>
    Secondary small
</Button>
`}
            boxtitle="JSX"
            wrapText={true}
            language="javascript"
            editable={false}
            height="150px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />

          <span className="headline">Danger small</span>
          <Button variant="danger" size="small" onClick={handleClick}>
            Danger small
          </Button>

          <CustomCodeEditor
            value={`import Button from '../Components/Buttons';

<Button variant="secondary" size='large' onClick={handleClick}>
    Danger small
</Button>
`}
            boxtitle="JSX"
            wrapText={true}
            language="javascript"
            editable={false}
            height="150px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />

          <span className="headline">Danger medium</span>
          <Button variant="danger" size="medium" onClick={handleClick}>
            Danger medium
          </Button>
          <CustomCodeEditor
            value={`import Button from '../Components/Buttons';

<Button variant="secondary" size='medium' onClick={handleClick}>
    Danger medium
</Button>
`}
            boxtitle="JSX"
            wrapText={true}
            language="javascript"
            editable={false}
            height="150px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />

          <span className="headline">Danger large</span>
          <Button variant="danger" size="large" onClick={handleClick}>
            Danger large
          </Button>

          <CustomCodeEditor
            value={`import Button from '../Components/Buttons';

<Button variant="secondary" size='large' onClick={handleClick}>
    Danger medium
</Button>
`}
            boxtitle="JSX"
            wrapText={true}
            language="javascript"
            editable={false}
            height="150px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />

          <span className="headline">Danger xlarge</span>
          <Button variant="danger" size="xlarge" onClick={handleClick}>
            Danger xlarge
          </Button>

          <CustomCodeEditor
            value={`import Button from '../Components/Buttons';

<Button variant="secondary" size='xlarge' onClick={handleClick}>
    Danger medium
</Button>
`}
            boxtitle="JSX"
            wrapText={true}
            language="javascript"
            editable={false}
            height="150px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />

          <span className="headline">Danger xlarge disabled</span>
          <Button variant="danger" size="xlarge" disabled onClick={handleClick}>
            Danger xlarge disabled
          </Button>

          <CustomCodeEditor
            value={`import Button from '../Components/Buttons';

<Button variant="secondary" size='xlarge' disabled onClick={handleClick}>
    Danger medium
</Button>
`}
            boxtitle="JSX"
            wrapText={true}
            language="javascript"
            editable={false}
            height="150px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />

          <span className="headline">Ghost transparent large</span>
          <Button background="color0" size="large" onClick={handleClick}>
            Ghost transparent large
          </Button>

          <CustomCodeEditor
            value={`import Button from '../Components/Buttons';

<Button background='color0' size='large' onClick={handleClick}>
    Ghost transparent
</Button>
`}
            boxtitle="JSX"
            wrapText={true}
            language="javascript"
            editable={false}
            height="150px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />

          <span className="headline">Ghost color 1 large</span>
          <Button background="color1" size="large" onClick={handleClick}>
            Ghost color 1 large
          </Button>

          <CustomCodeEditor
            value={`import Button from '../Components/Buttons';

<Button background='color1' size='large' onClick={handleClick}>
    Ghost color 1 large
</Button>
`}
            boxtitle="JSX"
            wrapText={true}
            language="javascript"
            editable={false}
            height="150px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />

          <span className="headline">Ghost color 2 large</span>
          <Button background="color2" size="large" onClick={handleClick}>
            Ghost color 2 large
          </Button>

          <CustomCodeEditor
            value={`import Button from '../Components/Buttons';

<Button background='color2' size='large' onClick={handleClick}>
    Ghost color 2 large
</Button>
`}
            boxtitle="JSX"
            wrapText={true}
            language="javascript"
            editable={false}
            height="150px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />

          <span className="headline">Ghost color 3 large</span>
          <Button background="color3" size="large" onClick={handleClick}>
            Ghost color 3 large
          </Button>

          <CustomCodeEditor
            value={`import Button from '../Components/Buttons';

<Button background='color3' size='large' onClick={handleClick}>
    Ghost color 3 large
</Button>
`}
            boxtitle="JSX"
            wrapText={true}
            language="javascript"
            editable={false}
            height="150px"
            highlightActiveLine={false}
            lightTheme="githubLight"
            darkTheme="dracula"
          />
        </div>
      </div>

      {/* Form elements ================================================ */}

      <h2 className="h2-title">Form elements</h2>
      <div className="row d-flex gap">
        <div className="radius-yes d-flex p-2 bg-yes col-12 gap folded">
          {/* Input ================================================ */}

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Name</div>
                <div className="small-font">Input with defaultValue, which can be changed</div>
              </div>
              <div className="align-wrapper d-flex align-center">
                <CustomInput
                  id="input-1"
                  label="Name"
                  placeholder="Enter text"
                  icon={<i className="fa-solid fa-right-to-bracket"></i>}
                  defaultValue="Name"
                  type="text"
                />
              </div>
            </div>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const editorContent = document.getElementById('input-1')?.value || '';
                alert('Editor content: ' + editorContent);
              }}
            >
              Input content
            </Button>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomInput} from '../Components/CustomFormElements';

return (
<div className='int-col-2 p-2 border-yes radius-yes'>
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomInput
                id="input-1"
                label="Name"
                placeholder="Enter text"
                icon={<i className="fa-solid fa-right-to-bracket"></i>}
                defaultValue="Dima"
                type="text"
            />
        </div>
    </div>
    <Button variant='primary' size='medium' onClick={() => {
            const editorContent = document.getElementById('input-1')
            ?.value || ''; alert('Editor content: ' + editorContent)}}>
            Input content
    </Button>
</div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Name</div>
                <div className="small-font">Input with value which can't be changed</div>
              </div>
              <CustomInput
                id="input-2"
                label="Name"
                placeholder="Enter text"
                icon={<i className="fa-solid fa-right-to-bracket"></i>}
                value="Last name"
                type="text"
              />
            </div>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const editorContent = document.getElementById('input-2')?.value || '';
                alert('Editor content: ' + editorContent);
              }}
            >
              Input content
            </Button>
          </div>

          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomInput} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomInput
                id="input-1"
                label="Name"
                placeholder="Enter text"
                icon={<i className="fa-solid fa-right-to-bracket"></i>}
                value="Dima"
                type="text"
            />
        </div>
        <Button variant='primary' size='medium' onClick={() => {
                const editorContent = document.getElementById('input-2')
                ?.value || ''; alert('Editor content: ' + editorContent)}}>
                Input content
        </Button>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Disabled</div>
                <div className="small-font">Enter your name</div>
              </div>
              <CustomInput
                id="input-3"
                label="Disabled"
                placeholder="Enter text"
                disabled={true}
                icon={<i className="fa-solid fa-right-to-bracket"></i>}
                value="Dima"
                type="text"
              />
            </div>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const editorContent = document.getElementById('input-3')?.value || '';
                alert('Editor content: ' + editorContent);
              }}
            >
              Input content
            </Button>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomInput} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomInput
                id="input-1"
                label="Disabled"
                placeholder="Enter text"
                disabled={true}
                icon={<i className="fa-solid fa-right-to-bracket"></i>}
                value="Dima"
                type="text"
            />
        </div>
        <Button variant='primary' size='medium' onClick={() => {
                const editorContent = document.getElementById('input-3')
                ?.value || ''; alert('Editor content: ' + editorContent)}}>
                Input content
        </Button>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Password</div>
                <div className="small-font">Enter your password</div>
              </div>
              <CustomInput
                id="password-1"
                label="Password"
                placeholder="Enter your password"
                toggleVisibility={true}
                type="password"
              />
            </div>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const editorContent = document.getElementById('password-1')?.value || '';
                alert('Editor content: ' + editorContent);
              }}
            >
              Input content
            </Button>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomInput} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomInput
                id="input-2"
                label="Password"
                placeholder="Enter your password"
                toggleVisibility={true}
                type="password"
            />
        </div>
        <Button variant='primary' size='medium' onClick={() => {
                const editorContent = document.getElementById('password-1')
                ?.value || ''; alert('Editor content: ' + editorContent)}}>
                Input content
        </Button>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          {/* Checkbox ================================================ */}

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Terms</div>
                <div className="small-font">Checkbox with defaultValue, which can be changed</div>
              </div>
              <CustomCheckbox
                id="terms"
                name="terms"
                label="Accept Terms and Conditions"
                defaultValue={true}
                onChange={(e) => console.log(e.target.checked)}
              />
            </div>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const editorContent = document.getElementById('terms')?.checked || '';
                alert('Editor content: ' + editorContent);
              }}
            >
              Input content
            </Button>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomCheckbox} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomCheckbox
                id="terms"
                name="terms"
                label="Accept Terms and Conditions"
                defaultValue={true}
                onChange={(e) => console.log(e.target.checked)}
            />
        </div>
        <Button variant='primary' size='medium' onClick={() => {
                const editorContent = document.getElementById('terms')
                ?.checked || ''; alert('Editor content: ' + editorContent)}}>
                Input content
        </Button>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Checked</div>
                <div className="small-font">
                  This is checked checkbox which can't be changed from code
                </div>
              </div>
              <CustomCheckbox
                id="prechecked"
                name="prechecked"
                label="I am already checked"
                checked={isAccepted}
                onChange={(e) => console.log(e.target.checked)}
              />
            </div>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const editorContent = document.getElementById('prechecked')?.checked || '';
                alert('Editor content: ' + editorContent);
              }}
            >
              Input content
            </Button>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomCheckbox} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomCheckbox
                id="prechecked"
                name="prechecked"
                label="I am already checked"
                checked={isAccepted}
                onChange={(e) => console.log(e.target.checked)}
            />
        </div>
        <Button variant='primary' size='medium' onClick={() => {
                const editorContent = document.getElementById('prechecked')
                ?.checked || ''; alert('Editor content: ' + editorContent)}}>
                Input content
        </Button>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Disabled</div>
                <div className="small-font">Disabled checkbox</div>
              </div>
              <CustomCheckbox
                id="disabled"
                name="disabled"
                label="This checkbox is disabled"
                disabled={true}
              />
            </div>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomCheckbox} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomCheckbox
                id="disabled"
                name="disabled"
                label="This checkbox is disabled"
                disabled={true}
            />
            </div>
        </div>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          {/* Toggle ================================================ */}

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Toggle</div>
                <div className="small-font">Toggle with defaultValue, which can be changed</div>
              </div>
              <CustomToggle
                id="toggle-status"
                label={isActive1 ? 'Active' : 'Inactive'}
                checked={isActive1} // Use checked to control toggle state
                onChange={(id, value) => setIsActive1(value)}
                disabled={false}
              />
            </div>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const editorContent = document.getElementById('toggle-status')?.checked || '';
                alert('Editor content: ' + editorContent);
              }}
            >
              Input content
            </Button>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomToggle} from '../Components/CustomFormElements';
const [isActive, setIsActive] = useState(true);


return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomToggle
                id="toggle-status"
                label={isActive ? 'Active' : 'Inactive'}
                checked={isActive} // Use checked to control toggle state
                onChange={(id, value) => setIsActive(value)}
                disabled={false}
            />
            </div>
            <Button variant='primary' size='medium' onClick={() => {
                    const editorContent = document.getElementById('toggle-status')
                    ?.checked || ''; alert('Editor content: ' + editorContent)}}>
                    Input content
            </Button>
        </div>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Toggle</div>
                <div className="small-font">
                  This is checked toggle which can't be changed from code
                </div>
              </div>
              <CustomToggle
                id="toggle-feature-1"
                label={isActive2 ? 'Active' : 'Inactive'}
                checked={isActive2}
                onChange={(id, value) => setIsActive2(value)}
                disabled={false}
              />
            </div>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const editorContent = document.getElementById('toggle-feature-1')?.checked || '';
                alert('Editor content: ' + editorContent);
              }}
            >
              Input content
            </Button>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomToggle} from '../Components/CustomFormElements';
const [isActive2, setIsActive2] = useState(true);


return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomToggle 
                id="toggle-feature"
                label={isActive2 ? 'Active' : 'Inactive'}
                checked={isFeatureEnabled}       
                onChange={(id, value) => setIsActive2(value)} 
                disabled={false} 
            />
            </div>
            <Button variant='primary' size='medium' onClick={() => {
                    const editorContent = document.getElementById('toggle-feature-1')
                    ?.checked || ''; alert('Editor content: ' + editorContent)}}>
                    Input content
            </Button>
        </div>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Disabled</div>
                <div className="small-font">Disabled toggle</div>
              </div>
              <CustomToggle
                id="toggle-feature-2"
                label="I'm disabled"
                onChange={() => console.log('Toggled!')}
                disabled={true}
              />
            </div>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomToggle} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomToggle 
                id="toggle-feature"
                label="I'm disabled"       
                onChange={() => console.log('Toggled!')} 
                disabled={true} 
            />
            </div>
        </div>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          {/* Radiobuttons ================================================ */}

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Radiobuttons</div>
                <div className="small-font">Select an option</div>
              </div>
              <CustomRadioGroup
                name="exampleGroup"
                options={[
                  { id: 'radio1', label: 'Option 1', value: 'option1' },
                  { id: 'radio2', label: "I'm disabled", value: 'option2', disabled: true },
                  { id: 'radio3', label: 'Option 3', value: 'option3' },
                ]}
                defaultValue="option1"
                onChange={handleRadioGroupChange}
                disabled={false}
              />
            </div>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const selectedOption =
                  document.querySelector('input[name="exampleGroup"]:checked')?.value || '';
                alert('Editor content: ' + selectedOption);
              }}
            >
              Input content
            </Button>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomRadioGroup} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomRadioGroup
                    name="exampleGroup"
                    options={
                        [
                            { id: 'radio1', label: 'Option 1', value: 'option1' },
                            { id: 'radio2', label: "I'm disabled", value: 'option2', disabled: true },
                            { id: 'radio3', label: 'Option 3', value: 'option3' },
                        ]
                    }
                    defaultValue="option1"
                    onChange={handleRadioGroupChange}
                    disabled={false}
                />
            </div>
            <Button variant='primary' size='medium' onClick={() => {
                    const selectedOption = document.querySelector('input[name="exampleGroup"]:checked')
                    ?.value || ''; alert('Editor content: ' + selectedOption)}}>
                    Input content
            </Button>
        </div>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          {/* Select ================================================ */}

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Single select</div>
                <div className="small-font">Single select box</div>
              </div>
              <CustomSelect
                id="select-id-1"
                label="Single Select"
                options={[
                  { value: '1', label: 'Option 1' },
                  { value: '2', label: 'Option 2' },
                  { value: '3', label: 'Option 3' },
                ]}
                multiSelect={false}
                onChange={(val) => console.log(val)}
              />
            </div>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const selectContent = document
                  .getElementById('select-id-1')
                  ?.querySelector('.select-display')
                  ?.getAttribute('data-value');
                alert('Selected val: ' + selectContent);
              }}
            >
              Select val
            </Button>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomSelect} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomSelect
                id='select-id'
                label="Single Select"
                options={[
                    { value: '1', label: 'Option 1' },
                    { value: '2', label: 'Option 2' },
                    { value: '3', label: 'Option 3' },
                ]}
                multiSelect={false}
                onChange={(val) => console.log(val)}
            />
            </div>
            <Button variant='primary' size='medium' onClick={() => {
                const selectContent = document
                    .getElementById('prompt-pattern')
                    ?.querySelector('.select-display')
                    ?.getAttribute('data-value');
                console.log('Selected Value:', selectContent);
            }}>
                Select value
            </Button>
        </div>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Single select</div>
                <div className="small-font">Single select with preselected value</div>
              </div>
              <CustomSelect
                id="select-id-2"
                label="Single Select"
                options={[
                  { value: '1', label: 'Option 1' },
                  { value: '2', label: 'Option 2' },
                  { value: '3', label: 'Option 3' },
                ]}
                value={'2'}
                multiSelect={false}
                onChange={(val) => console.log(val)}
              />
            </div>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const selectContent = document
                  .getElementById('select-id-2')
                  ?.querySelector('.select-display')
                  ?.getAttribute('data-value');
                alert('Selected val: ' + selectContent);
              }}
            >
              Select val
            </Button>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomSelect} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomSelect
                id='select-id-2'    
                label="Single Select"
                options={[
                    { value: '1', label: 'Option 1' },
                    { value: '2', label: 'Option 2' },
                    { value: '3', label: 'Option 3' },
                ]}
                value={'2'}
                multiSelect={false}
                onChange={(val) => console.log(val)}
            />
            </div>
            <Button variant='primary' size='medium' onClick={() => {
                const selectContent = document
                    .getElementById('select-id-2')
                    ?.querySelector('.select-display')
                    ?.getAttribute('data-value');
                console.log('Selected Value:', selectContent);
            }}>Select val</Button>
        </div>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Multiple select</div>
                <div className="small-font">Select many options</div>
              </div>
              <CustomSelect
                id="multiple-select-1"
                label="Single Select"
                options={[
                  { value: '1', label: 'Option 1' },
                  { value: '2', label: 'Option 2' },
                  { value: '3', label: 'Option 3' },
                ]}
                multiSelect={true}
                onChange={(val) => console.log(val)}
              />
            </div>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const selectContent = document
                  .getElementById('multiple-select-1')
                  ?.querySelector('.select-display')
                  ?.getAttribute('data-value');
                alert('Selected vals: ' + selectContent);
              }}
            >
              Select val(s)
            </Button>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomSelect} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomSelect
                id='multiple-select-1'
                label="Single Select"
                options={[
                    { value: '1', label: 'Option 1' },
                    { value: '2', label: 'Option 2' },
                    { value: '3', label: 'Option 3' },
                ]}
                multiSelect={true}
                onChange={(val) => console.log(val)}
            />
            </div>
            <Button variant='primary' size='medium' onClick={() => {
                const selectContent = document
                    .getElementById('multiple-select-1')
                    ?.querySelector('.select-display')
                    ?.getAttribute('data-value');
                alert('Selected vals: ' + selectContent);
            }}>Select val(s)</Button>
        </div>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Multiple select</div>
                <div className="small-font">Multiple select with preselected options</div>
              </div>
              <CustomSelect
                id="select-with-preselected"
                label="Single Select"
                options={[
                  { value: '1', label: 'Option 1' },
                  { value: '2', label: 'Option 2' },
                  { value: '3', label: 'Long Option 3' },
                  { value: '4', label: 'Very long Option 4' },
                  { value: '5', label: 'The Longest Option 5' },
                  { value: '6', label: 'You tell me option 6' },
                  { value: '7', label: 'What else do you need 7' },
                ]}
                value={['1', '3']}
                multiSelect={true}
                onChange={(val) => console.log(val)}
              />
            </div>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const selectContent = document
                  .getElementById('select-with-preselected')
                  ?.querySelector('.select-display')
                  ?.getAttribute('data-value');
                alert('Selected val: ' + selectContent);
              }}
            >
              Select val
            </Button>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomSelect} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomSelect
                id='select-with-preselected'
                label="Single Select"
                options={[
                    { value: '1', label: 'Option 1' },
                    { value: '2', label: 'Option 2' },
                    { value: '3', label: 'Long Option 3' },
                    { value: '4', label: 'Very long Option 4' },
                    { value: '5', label: 'The Longest Option 5' },
                    { value: '6', label: 'You tell me option 6' },
                    { value: '7', label: 'What else do you need 7' },
                ]}
                value={['1', '3']}
                multiSelect={true}
                onChange={(val) => console.log(val)}
            />
            </div>
            <Button variant='primary' size='medium' onClick={() => {
                const selectContent = document
                    .getElementById('select-with-preselected')
                    ?.querySelector('.select-display')
                    ?.getAttribute('data-value');
                alert('Selected val: ' + selectContent);
            }}>Select val</Button>
        </div>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Disabled select</div>
                <div className="small-font">No options can be selected</div>
              </div>
              <CustomSelect
                label="Single Select"
                options={[
                  { value: '1', label: 'Option 1' },
                  { value: '2', label: 'Option 2' },
                  { value: '3', label: 'Option 3' },
                ]}
                value={['1', '3']}
                multiSelect={true}
                disabled={true}
                onChange={(val) => console.log(val)}
              />
            </div>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomSelect} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomSelect
                label="Single Select"
                options={[
                    { value: '1', label: 'Option 1' },
                    { value: '2', label: 'Option 2' },
                    { value: '3', label: 'Option 3' },
                ]}
                value={['1', '3']}
                multiSelect={true}
                disabled={true}
                onChange={(val) => console.log(val)}
            />
            </div>
        </div>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          {/* Slider ================================================ */}

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Slider</div>
                <div className="small-font">Select the brightness</div>
              </div>
              <CustomSlider
                id="custom-slider-1"
                label="Brightness"
                min={0}
                max={100}
                oneStep={1}
                suffix=" %"
                value={'25'}
                onChange={(val) => console.log(val)}
              />
            </div>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const sliderValue = document
                  .getElementById('custom-slider-1')
                  ?.querySelector('input[type="range"]')?.value;
                alert('Slider value: ' + sliderValue);
              }}
            >
              Get Slider Value
            </Button>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomSlider} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomSlider
                id="custom-slider-1"    
                label="Brightness"
                min={0}
                max={100}
                oneStep={1}
                suffix=" %"
                value={'25'}
                onChange={(val) => console.log(val)}
            />
            </div>
            <Button variant="primary" size="medium" onClick={() => {
                    const sliderValue = document.getElementById('custom-slider-1')?.querySelector('input[type="range"]')?.value;
                    alert('Slider value: ' + sliderValue);
                }}
            >
                Get Slider Value
            </Button>
        </div>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Disabled slider</div>
                <div className="small-font">No options can be selected</div>
              </div>
              <CustomSlider
                label="Brightness"
                min={0}
                max={100}
                oneStep={1}
                suffix=" %"
                value={'25'}
                disabled={true}
                onChange={(val) => console.log(val)}
              />
            </div>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomSlider} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomSlider
                label="Brightness"
                min={0}
                max={100}
                oneStep={1}
                suffix=" %"
                value={'25'}
                disabled={true}
                onChange={(val) => console.log(val)}
            />
            </div>
        </div>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          {/* Number Input ================================================ */}

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Number input</div>
                <div className="small-font">Select the number</div>
              </div>
              <CustomNumberInput
                id="custom-number-input-1"
                label="label"
                value={5}
                onChange={(val) => console.log(val)}
                disabled={false}
                min={2}
                max={100}
                step={1}
              />
            </div>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const numberInputValue = document
                  .getElementById('custom-number-input-1')
                  ?.querySelector('.number-input-display')?.value;
                alert('Number Input Value: ' + numberInputValue);
              }}
            >
              Get Number Input Value
            </Button>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomNumberInput} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomNumberInput
                id="custom-number-input-1"
                label="label"
                value={5}
                onChange={(val) => console.log(val)}
                disabled={false}
                min = {2}
                max = {100}
                step = {1}
            />
            </div>
            <Button variant="primary" size="medium" onClick={() => {
                const numberInputValue = document.getElementById('custom-number-input-1')?.querySelector('.number-input-display')?.value;
                alert('Number Input Value: ' + numberInputValue);
            }}
            >
                Get Number Input Value
            </Button>
        </div>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Disabled number input</div>
                <div className="small-font">Select the number</div>
              </div>
              <CustomNumberInput
                label=""
                value={5}
                onChange={(val) => console.log(val)}
                disabled={true}
                min={2}
                max={100}
                step={4}
              />
            </div>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomNumberInput} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomNumberInput
                label=""
                value={5}
                onChange={(val) => console.log(val)}
                disabled={true}
                min = {2}
                max = {100}
                step = {4}
            />
            </div>
        </div>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          {/* Circle rating ================================================ */}

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Star rating</div>
                <div className="small-font">Set the star rating</div>
              </div>
              <CustomCircleRating
                id="rating-component-1"
                label="Rate Your Experience"
                value={0}
                onChange={(val) => console.log(val)}
                isHalf={true}
                mandatory={false}
                disabled={false}
              />
            </div>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const ratingValue =
                  document
                    .getElementById('rating-component-1')
                    ?.querySelectorAll('.circle-icon.filled').length || 0;
                alert('Rating Value: ' + ratingValue);
              }}
            >
              Get Rating Value
            </Button>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomCircleRating} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomCircleRating
                id="rating-component-1"
                label="Rate Your Experience"
                value={0}
                onChange={(val) => console.log(val)}
                isHalf={true}
                mandatory={false}
                disabled={false}
            />
            </div>
            <Button variant="primary" size="medium" onClick={() => {
                const ratingValue = document
                .getElementById('rating-component-1')
                ?.querySelectorAll('.circle-icon.filled').length || 0;
                alert('Rating Value: ' + ratingValue);
            }}
            >
                Get Rating Value
            </Button>
        </div>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Disabled rating</div>
                <div className="small-font">I'm disabled</div>
              </div>
              <CustomCircleRating
                label="Rate Your Experience"
                value={3.5}
                onChange={(val) => console.log(val)}
                isHalf={true}
                mandatory={false}
                disabled={true}
              />
            </div>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomCircleRating} from '../Components/CustomFormElements';

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
            <CustomCircleRating
                label="Rate Your Experience"
                value={3.5}
                onChange={(val) => console.log(val)}
                isHalf={true}
                mandatory={false}
                disabled={true}
            />
            </div>
        </div>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          {/* File upload ================================================ */}

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">File upload zone</div>
                <div className="small-font">Drag & Drop file</div>
              </div>

              <ConfirmationProvider>
                <CustomFileUpload
                  multiple={true}
                  maxFileSize={2 * 1024 * 1024} // 2 MB
                  allowedFormats={['image/png', 'image/jpeg', 'application/pdf']}
                  showUploadedFiles={true}
                  allowFileDeletion={true}
                />
              </ConfirmationProvider>
            </div>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomFileUpload} from '../Components/CustomFormElements';
import { useAlert } from '../Components/AlertContext';
import { ConfirmationProvider } from '../Components/ConfirmationContext';
const [uploadedFiles, setUploadedFiles] = useState([]);

return (
    <div className='input-block d-flex flex-row justify-between'>
        <div className='input-description'>
            <div className='input-title'>Name</div>
            <div className='small-font'>Input with defaultValue, which can be changed</div>
        </div>
        <div className='align-wrapper d-flex align-center'>
                <ConfirmationProvider>
                    <CustomFileUpload
                        multiple={false}
                        maxFileSize={2 * 1024 * 1024} // 2 MB
                        allowedFormats={['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']}
                        showUploadedFiles={true}
                        allowFileDeletion={true}
                        onFileSelect={(files) => setUploadedFiles(files)} // Capture selected files
                    />
                </ConfirmationProvider>
            </div>
        </div>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          {/* WYSIWYG Editor ================================================ */}

          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomWYSIWYGEditor
              id="custom-wysiwyg-editor" // Add a unique id
              label="Role"
              mandatory={true}
              disabled={false}
              addedText=""
              resizable={true}
              height="300"
            />
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const editorContent =
                  document.getElementById('custom-wysiwyg-editor')?.querySelector('textarea')
                    ?.value || '';
                alert('Editor content' + editorContent);
              }}
            >
              Editor content
            </Button>
          </div>

          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomWYSIWYGEditor} from '../Components/CustomFormElements';

return (
    <div className='int-col-2 p-2 border-yes radius-yes'>
        <CustomWYSIWYGEditor 
            id="custom-wysiwyg-editor" // Add a unique id
            label="Role"
            mandatory={true}
            disabled={false}
            addedText=""
            resizable={true}
            height="300"
        />
        <Button variant='primary' size='medium' onClick={() => {const editorContent = document.getElementById('custom-wysiwyg-editor')?.querySelector('textarea')?.value || ''; alert('Editor content' + editorContent)}}>Editor content</Button>
    </div>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          {/* Custom textarea ================================================ */}

          <div className="int-col-2 p-2 border-yes radius-yes">
            <div className="input-block d-flex flex-row justify-between">
              <div className="input-description">
                <div className="input-title">Custom texarea</div>
                <div className="small-font">This is custom textarea</div>
              </div>
              <CustomTextarea
                id="textarea-example"
                label="Textarea label"
                name="Textarea name"
                type="text"
                value={''}
                addedText={''}
                resizable={false}
                height="200px"
              />
            </div>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                const textarea =
                  document.getElementById('textarea-example')?.querySelector('textarea')?.value ||
                  '';
                alert('Textarea Value: ' + textarea);
              }}
            >
              Get Textarea Value
            </Button>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomTextarea} from '../Components/CustomFormElements';

return (
    <div className='int-col-2 p-2 border-yes radius-yes'>
        <div className='input-block d-flex flex-row justify-between'>
            <div className='input-description'>
                <div className='input-title'>Disabled rating</div>
                <div className='small-font'>I'm disabled</div>
            </div>
            <CustomTextarea 
                id="textarea"
                label="Textarea label"
                name="Textarea name"
                type="text"
                value={''}
                addedText={''}
                resizable={false}
                height="200px"
            />
        </div>
    </div>
    <Button
        variant="primary"
        size="medium"
        onClick={() => {
            const textarea = document.getElementById('textarea-example')?.querySelector('textarea')?.value || '';
            alert('Textarea Value: ' + textarea);
        }}
    >
    Get Textarea Value
    </Button>
);
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="200px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          {/* Code editor ================================================ */}

          <div className="int-col-4 p-2 border-yes radius-yes">
            <CustomCodeEditor
              id="code-editor-1"
              value={`import {CustomWYSIWYGEditor} from '../Components/CustomFormElements';

return (
  
        <CustomCodeEditor
            id="code-editor-1"    
            value={}
            boxtitle='JSX'
            wrapText={true}
            language="javascript"
            editable={false}
            height='200px'
            highlightActiveLine={false}
            lightTheme='githubLight'
            darkTheme='dracula'
        />

    <Button
        variant="primary"
        size="medium"
        onClick={() => {
            const editorContent = document
                .getElementById('code-editor-1')
                ?.querySelector('.cm-content')
                ?.innerText || '';
            alert('Editor Content: ' + editorContent);
        }}
    >
        Get Code
    </Button>
);
    `}
              boxtitle="Code editor - not-editable example"
              wrapText={true}
              language="javascript"
              editable={false}
              height="150px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>
          <Button
            variant="primary"
            size="medium"
            onClick={() => {
              const editorContent =
                document.getElementById('code-editor-1')?.querySelector('.cm-content')?.innerText ||
                '';
              alert('Editor Content: ' + editorContent);
            }}
          >
            Get Code
          </Button>

          <div className="int-col-4 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import {CustomWYSIWYGEditor} from '../Components/CustomFormElements';

return (
   
        <CustomCodeEditor
            value={}
            boxtitle='JSX'
            wrapText={true}
            language="javascript"
            editable={true}
            height='200px'
            highlightActiveLine={false}
            lightTheme='githubLight'
            darkTheme='dracula'
        />
  
);
    `}
              boxtitle="Code editor - editable example"
              wrapText={true}
              language="javascript"
              editable={true}
              height="150px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          <div className="int-col-4 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import { useAlert } from '../Components/AlertContext';
import { ConfirmationProvider } from '../Components/ConfirmationContext';

showConfirmation(
        'Are you sure you want to delete this item?',
        () => {
            try {
                // Simulate a delete operation
                showAlert('success', 'Item was successfully deleted!');
                showAlert('warning', 'Maybe it was a bad idea!');
            } catch (error) {
                showAlert('fail', 'Failed to delete the item!');
            }
        }
    );
    <ConfirmationProvider>
        </Component>
    </ConfirmationProvider>
`}
              boxtitle="Confirmation message and alert"
              wrapText={true}
              language="javascript"
              editable={true}
              height="450px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>

          {/* Custom form ================================================ */}

          <div className="int-col-2 p-2 border-yes radius-yes">
            <form
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault(); // Prevent default form submission behavior
                  console.log('Paste here login function');
                }
              }}
            >
              <div className="auth-container">
                <h2>Sign In to Your Account</h2>
                <CustomInput
                  id="email"
                  label=""
                  placeholder="Enter your email"
                  type="login"
                  icon={<i className="fa-solid fa-right-to-bracket"></i>}
                />
                <CustomInput
                  id="password"
                  label=""
                  placeholder="Enter your password"
                  toggleVisibility={true}
                  type="password"
                />
                <button
                  className="auth-btn"
                  id="sign-in-btn"
                  onClick={'handleLogin'} // ✅ Trigger validation and login logic
                >
                  Sign In
                </button>
              </div>
            </form>
          </div>
          <div className="int-col-2 p-2 border-yes radius-yes">
            <CustomCodeEditor
              value={`import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { CustomInput } from '../Components/CustomFormElements';
import { useAlert } from '../Components/AlertContext';
import { Link } from 'react-router-dom';
import './LoginPage.css';

// ✅ Validation Function
const validateFields = (fields, validationRules) => {
    let isValid = true;

    fields.forEach((fieldId) => {
        const field = document.getElementById(fieldId);
        const rules = validationRules[fieldId] || {};
        const value = field?.value?.trim() || '';

        // Check required
        if (rules.required && !value) {
            field.classList.add('input-error');
            isValid = false;
        } else {
            field.classList.remove('input-error');
        }

        // Check regex
        if (rules.regex && !rules.regex.test(value)) {
            field.classList.add('input-error');
            isValid = false;
        } else {
            field.classList.remove('input-error');
        }
    });

    return isValid;
};

const LoginPageContent = () => {
    const { loginWithRedirect } = useAuth0();
    const { showAlert } = useAlert();

    // ✅ Validation Rules
    const validationRules = {
        email: {
            required: true,
            regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // Email regex
        },
        password: {
            required: true,
            regex: /^.{6,}$/, // At least 6 characters
        },
    };

    // ✅ Unified Validation Handler
    const handleLogin = (e) => {
        e.preventDefault(); // Prevent default form behavior on Enter key or button click

        const isValid = validateFields(['email', 'password'], validationRules);

        if (isValid) {
            showAlert('success', 'Login successful! Redirecting...');
            loginWithRedirect();
        } else {
            showAlert('fail', 'Please ensure all fields are filled correctly.');
        }
    };

    return (
        <div className='login-page-wrapper'>
            <div className='sign-up-box'></div>
            <div className='sing-in-box'>
                <form
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault(); // Prevent default form submission behavior
                            handleLogin(e);
                        }
                    }}
                >
                    <div className="auth-container">
                        <h2>Sign In to Your Account</h2>
                        <CustomInput
                            id="email"
                            label=""
                            placeholder="Enter your email"
                            type="login"
                            icon={<i className="fa-solid fa-right-to-bracket"></i>}
                        />
                        <CustomInput
                            id="password"
                            label=""
                            placeholder="Enter your password"
                            toggleVisibility={true}
                            type="password"
                        />
                        <button
                            className="auth-btn"
                            id="sign-in-btn"
                            onClick={handleLogin} // ✅ Trigger validation and login logic
                        >
                            Sign In
                        </button>
                        <div className='buttons-separator'>or</div>
                        <Link to='/signup' className='sign-up-button' id="create-account-btn">
                            Create an account
                        </Link>
                        <a href="/forgot-password">Forgot Password?</a>
                    </div>
                </form>
            </div>
        </div>
    );
};

const LoginPage = () => <LoginPageContent />;

export default LoginPage;
    `}
              boxtitle="JSX"
              wrapText={true}
              language="javascript"
              editable={false}
              height="900px"
              highlightActiveLine={false}
              lightTheme="githubLight"
              darkTheme="dracula"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListOfComponents;
